import { getFormattedCurrency } from '@core/Utils/Intl/GetFormattedCurrency';

import type { LeasingVehiclePricingProps } from '../LeasingVehicleAttributes.entity';

import styles from './LeasingPrice.module.css';

const LeasingPrice = ({ leasingPrice, strings }: LeasingVehiclePricingProps) => {
  const { vatMth, vatInitial } = leasingPrice;

  if (!vatMth || !vatInitial) return null;

  return (
    <>
      <p className={styles.from}>{strings.from}</p>

      <div className={styles.leasingPriceBlock}>
        <span className={styles.monthlyPrice}>{getFormattedCurrency(vatMth)}</span>

        <span className={styles.leasingPriceText}>{strings.vat}</span>
      </div>

      <p className={styles.initialRentalText}>
        {strings.initial}{' '}
        <strong className={styles.priceContent}>{getFormattedCurrency(vatInitial)}</strong>
      </p>
    </>
  );
};

export default LeasingPrice;
